import React, { useEffect, useState, useRef } from 'react';

const Message = ({ message, type, interval, onComplete }) => {
	const [progress, setProgress] = useState(0);
	const [isPaused, setIsPaused] = useState(false);
	const [isExiting, setIsExiting] = useState(false);
	const [isEntering, setIsEntering] = useState(true);
	const timerRef = useRef(null);

	useEffect(() => {
		const enterTimer = setTimeout(() => {
			setIsEntering(false);
		}, 50);

		return () => clearTimeout(enterTimer);
	}, []);

	useEffect(() => {
		if (isEntering) return;

		const incrementInterval = 100;
		const totalSteps = interval / incrementInterval;
		const stepSize = 100 / totalSteps;

		const startTimer = () => {
			timerRef.current = setInterval(() => {
				if (!isPaused) {
					setProgress((prev) => {
						const newProgress = prev + stepSize;
						if (newProgress >= 100) {
							setIsExiting(true);
							setTimeout(() => {
								if (onComplete) {
									onComplete();
								}
							}, 300);
							return 100;
						}
						return newProgress;
					});
				}
			}, incrementInterval);
		};

		startTimer();

		return () => {
			if (timerRef.current) {
				clearInterval(timerRef.current);
			}
		};
	}, [interval, isPaused, onComplete, isEntering]);

	const handleMouseEnter = () => {
		setIsPaused(true);
	};

	const handleMouseLeave = () => {
		setIsPaused(false);
	};

	const handleTouchStart = () => {
		setIsPaused(true);
	};

	const handleTouchEnd = () => {
		setIsPaused(false);
	};

	const getAnimationClasses = () => {
		if (isExiting) {
			return 'transform translate-x-full opacity-0';
		}
		if (isEntering) {
			return 'transform translate-x-full opacity-0';
		}
		return 'transform translate-x-0 opacity-100';
	};

	return (
		<div
			role={type === 'success' ? 'status' : 'alert'}
			className={`relative w-full py-[16px] px-[8px] border border-[#E5E7EB] bg-white rounded-[8px] flex flex-col gap-[8px] transition-all duration-300 ease-in-out ${getAnimationClasses()}`}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onTouchStart={handleTouchStart}
			onTouchEnd={handleTouchEnd}
			onFocus={() => setIsPaused(true)}
			onBlur={() => setIsPaused(false)}
		>
			<button
				type="button"
				aria-label="Dismiss notification"
				className="absolute top-0 right-0 p-2 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black rounded"
				onClick={onComplete}
			>
				<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
				</svg>
			</button>
			<p className="font-inter text-[#111827] text-[14px]/[18px]">{message}</p>
			<div className="bg-[#F4F4F4] h-[6px] rounded-[4px] relative">
				<div
					className={`${
						type === 'success' ? 'bg-green-600' : 'bg-red-500'
					} h-[6px] rounded-[4px] absolute left-0 top-0 transition-all duration-100 ease-linear`}
					style={{ width: `${progress}%` }}
				></div>
			</div>
		</div>
	);
};

export default Message;
